export class TableItem<T> {
  constructor(
    public model: T,
    public selected: boolean = false
  ) {}
}
